export default __webpack_public_path__ + "static/media/NunitoSans-Regular.87d92665.ttf";